import OperationalProcessesReportPage from "../../shared/OperationalProcessesReportPage";

const SolarentOperatorOperationalProcessesReportPage = () => (
  <OperationalProcessesReportPage operationsSource="SolarentOperator" />
);

export default SolarentOperatorOperationalProcessesReportPage;
